import { render } from "./PublicationSettings.vue?vue&type=template&id=1a770c7a"
import script from "./PublicationSettings.vue?vue&type=script&lang=js"
export * from "./PublicationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__